import { useState } from 'react'
import { Button, message } from 'antd'
import { BellOutlined, CloseOutlined } from '@ant-design/icons'
import { useWebPush } from 'hooks/useWebPush'

const CHAVE = 'yrm:convite-push'

const dispensado = () => {
  try { return Boolean(localStorage.getItem(CHAVE)) } catch { return false }
}

// O navegador só ativa notificação com um clique: convida uma vez, sem insistir.
export default function ConvitePush() {
  const webPush = useWebPush()
  const [fechado, setFechado] = useState(dispensado)

  if (fechado || webPush.status !== 'available') return null

  const fechar = () => {
    try { localStorage.setItem(CHAVE, '1') } catch { /* sem armazenamento: só fecha */ }
    setFechado(true)
  }

  const ativar = async () => {
    try {
      if (await webPush.enable()) message.success('Pronto: os avisos chegam neste aparelho.')
    } catch {
      message.error('Não foi possível ativar os avisos neste aparelho.')
    }
    fechar()
  }

  return (
    <div
      role='dialog'
      aria-label='Ativar avisos neste aparelho'
      style={{
        position: 'fixed', right: 16, bottom: 88, zIndex: 1000, maxWidth: 'calc(100vw - 32px)',
        display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px',
        background: 'var(--yrm-surface)', border: '1px solid var(--yrm-border)', borderRadius: 10, boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
      }}
    >
      <BellOutlined style={{ fontSize: 18, color: 'var(--yrm-heading)' }} />
      <span>Receber intimações e prazos neste aparelho?</span>
      <Button type='primary' size='small' loading={webPush.loading} onClick={ativar}>Ativar</Button>
      <Button type='text' size='small' icon={<CloseOutlined />} aria-label='Agora não' onClick={fechar} />
    </div>
  )
}
